/* eslint-disable global-require */
let configureStore = null;
if (process.env.NODE_ENV === 'production') {
  ({ default: configureStore } = require('./configureStore.prod'));
} else {
  ({ default: configureStore } = require('./configureStore.dev'));
}

module.exports = (slices) => configureStore(slices);
/* eslint-enable global-require */
